import React from "react";
import InputWithShortcuts from "src/components/inputs/inputWithShortcuts";
import SelectMenu from "src/components/selectMenu";

interface IFiltersAuthserverProps {
  onSearch: (value: string) => void;
  onOptionEnvironmentChange: (value: string) => void;
  optionsEnvironment: { value: string; label: string }[];
}

export const FiltersAuthserver: React.FC<IFiltersAuthserverProps> = ({
  onSearch,
  onOptionEnvironmentChange,
  optionsEnvironment,
}) => {
  return (
    <div className="flex flex-row justify-start items-start">
      <InputWithShortcuts
        onSearch={(value) => onSearch(value)}
        placeholder="Search by name"
        className="w-[20vw] mr-2"
      />
      <SelectMenu
        options={optionsEnvironment}
        onChange={onOptionEnvironmentChange}
        placeholder="Environment"
        className="min-w-[17vw] text-gray-700 mr-2"
        defaultValue="GET"
      />
    </div>
  );
};
